
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M9 11.2h2V7.244H9V11.2zm1 3.91a.955.955 0 110-1.912.955.955 0 010 1.911zm7.871.567l-7.044-12.2a.954.954 0 00-1.653 0l-7.045 12.2a.955.955 0 00.827 1.432h14.086a.956.956 0 00.83-1.432z"}})])
          )
        }
      }
    